import DriverCashTransactions from "../../services/api/DriverCashTransactions";
import { getPath, getQueryParams } from "../../utils";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import qs from "qs";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in driver cash transaction actions:", err);
}

export const setDriverCashTransactionsList = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_CASH_TRANSACTIONS_LIST,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_DRIVER_CASH_TRANSACTIONS,
    payload,
  };
};

export const setCurrentPageDriverCashTransactions = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_DRIVER_CASH_TRANSACTIONS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_DRIVER_CASH_TRANSACTIONS,
    payload,
  };
};

export const getDriverCashTransactionsList =
  (filters = {}, pageRequest = {}, mappingFilters) =>
  async (dispatch) => {
    try {
      if (!pageRequest.page) {
        pageRequest.page = 1;
      }
      let newFilters = { ...filters };
      if (newFilters["type"]) {
        newFilters["types"] = [newFilters["type"]];
        delete newFilters["type"];
      }
      if (mappingFilters) {
        newFilters["types"] = mappingFilters;
      }
      let finalPayload = {
        ...pageRequest,
        ...newFilters,
      };
      const queryParamsString = qs.stringify(finalPayload, {
        addQueryPrefix: true,
        encode: false,
      });
      dispatch(setLoader(true));
      let response = await DriverCashTransactions.getCashTransactionsList(
        queryParamsString
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setDriverCashTransactionsList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(
            setCurrentPageDriverCashTransactions(
              getPath(pageRequest, "page", 1)
            )
          );
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
